import Navbar from '../../components/navbar/navbar'
import { Categories } from './Categories'
import { Subcategories } from './Subcategories'

import { Container } from './styles'

export function CategoriesSubcategories() {
  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <Categories />
        <Subcategories />
      </Container>
    </>
  )
}
